<div class="adn-form-field"
    [ngClass]="{'adn-form-field-invalid': !errorStateMatcher.valid, 'adn-form-field-disabled': disabled}">
    <label>
        <span *ngIf="iconClass" class="fal fa-fw" [ngClass]="iconClass" aria-hidden="true">&nbsp;</span>{{label}}
        <ng-content select="app-text-label"></ng-content><span *ngIf="required">&nbsp;*</span>
    </label>
    <div class="adn-form-field-content">
        <span class="input-prefix" *ngIf="prefix">
            {{prefix}}
        </span>
        <input *ngIf="!rows" class="input-style" type="text" [(ngModel)]="value" [placeholder]="placeholder"
            (blur)="onBlur()" [maxlength]="maxlength" [minlength]="minlength" [required]="required"
            [disabled]="disabled" autocomplete="none" />
        <textarea *ngIf="rows" class="input-style" [(ngModel)]="value" [placeholder]="placeholder" (blur)="onBlur()"
            [rows]="rows" [minlength]="minlength" [required]="required" [disabled]="disabled"
            autocomplete="none"></textarea>
        <div class="input-icon" *ngIf="value">
            <button mat-button mat-icon-button matSuffix *ngIf="value && !required && !disabled" type="button"
                (click)="onClear()" title="{{ 'field.clear.label' | translate}}" tabindex="-1">
                <span class="fal fa-fw fa-times-circle"></span>
            </button>
        </div>
        <app-help-popup-button class="input-icon" *ngIf="helpUri" [uri]="helpUri"></app-help-popup-button>
    </div>
</div>
<div class="adn-form-field-hint" *ngIf="errorStateMatcher.valid && hint">{{hint}}</div>
<div class="adn-form-field-error" *ngIf="!errorStateMatcher.valid">
    <span class="error-icon fal fa-fw fa-exclamation-circle"></span>&nbsp;<span
        class="error-text">{{errorStateMatcher.errorKey | translate}}</span>
</div>